import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Flow } from 'signup-constants/Flow';
import { getIntegrationName } from '../utils/getIntegrationName';
import { isFlow } from '../utils/isFlow';
import Small from 'UIComponents/elements/Small';
import { usePrivacyBanner } from './usePrivacyBanner';
import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { StyledUILink } from './TextInput.styles';
import { getLegalLink } from '../legal/getLegalLink';
const StyledPrivacyBanner = styled.div.withConfig({
  displayName: "PrivacyBanner__StyledPrivacyBanner",
  componentId: "sc-1a0dwy3-0"
})(["margin-top:20px;", ""], props => props.theme.embedded && `margin-top: 2px;`);
const PrivacyTextIntegration = styled.div.withConfig({
  displayName: "PrivacyBanner__PrivacyTextIntegration",
  componentId: "sc-1a0dwy3-1"
})(["border-bottom:1px solid ", ";margin-bottom:10px;padding-bottom:10px;margin-top:25px;"], BATTLESHIP);

const PrivacyBanner = () => {
  const {
    privacyPolicyTextI18nLabel,
    shouldShowPrivacyBanner,
    handleClickTermsOfService,
    handleClickPrivacyPolicy
  } = usePrivacyBanner();

  if (!shouldShowPrivacyBanner) {
    return null;
  }

  const LegitimateInterest = /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: privacyPolicyTextI18nLabel,
    options: {
      termsOfServiceLink: /*#__PURE__*/_jsx(StyledUILink, {
        href: getLegalLink('terms-of-service'),
        onClick: handleClickTermsOfService,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "legal.termsOfServiceLink"
        })
      }, "gdprPolicy"),
      privacyPolicyLink: /*#__PURE__*/_jsx(StyledUILink, {
        external: true,
        href: getLegalLink('privacy-policy'),
        onClick: handleClickPrivacyPolicy,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "legal.privacyPolicyLink"
        })
      }, "gdprPolicy"),
      integrationName: getIntegrationName()
    }
  });

  if (isFlow(Flow.Integrations)) {
    return /*#__PURE__*/_jsx(StyledPrivacyBanner, {
      className: "text-center",
      children: /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [/*#__PURE__*/_jsx(PrivacyTextIntegration, {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: 'legal.integrationsLegalText',
            options: {
              integrationName: getIntegrationName()
            }
          })
        }), LegitimateInterest]
      })
    });
  }

  return /*#__PURE__*/_jsx(StyledPrivacyBanner, {
    className: "text-center",
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: LegitimateInterest
    })
  });
};

export default PrivacyBanner;